export const capitalizeFirstLetters = (text) => {
  if (!text || text === null) return "";
  return text.toLowerCase().replace(/(^|\s)\S/g, (char) => char.toUpperCase());
};
